<template>
  <section class="page-shell guides-page">
    <div class="section-heading compact-heading">
      <button class="back-link" @click="navigate('home')">← Home</button>
      <span class="eyebrow"><span></span>Decision guides</span>
      <h1>Original field notes for <em>clearer choices.</em></h1>
      <p>CalmDecide is not only a randomizer. These guides explain the thinking behind faster everyday decisions, structured big choices, and calmer reflection.</p>
    </div>

    <div class="guide-grid">
      <article v-for="guide in guides" :key="guide.slug" class="guide-card">
        <span>{{ guide.category }} · {{ guide.readTime }}</span>
        <h2>{{ guide.title }}</h2>
        <p>{{ guide.summary }}</p>
        <button @click="navigate('guide', guide.slug)">Read guide →</button>
      </article>
    </div>
  </section>
</template>

<script>
import guides from '../content/guides'

export default {
  name: 'GuidesView',
  inject: ['navigate'],
  data: () => ({ guides })
}
</script>
